import { render, staticRenderFns } from "./ShareSandModal.vue?vue&type=template&id=f52fd2f0&scoped=true"
import script from "./ShareSandModal.vue?vue&type=script&lang=js"
export * from "./ShareSandModal.vue?vue&type=script&lang=js"
import style0 from "./ShareSandModal.vue?vue&type=style&index=0&id=f52fd2f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f52fd2f0",
  null
  
)

export default component.exports